import React from 'react'

const Field = ({ component: Component, ...restProps }) => <Component {...restProps} />

export default Field
